export const Images = {
    ICON_ACCOUNT_LEFT: require('../assets/img/icon-account-left.png'),
    ICON_ACCOUNT_RIGHT: require('../assets/img/icon-account-right.png'),
    BETARKY: require('../assets/img/betarky.png'),
    CD: require('../assets/img/cd-obal.jpg'),
    LOGO: require('../assets/img/logo.png'),
    IMG_1: require('../assets/img/img-1.jpg'),
}